import ReturnPolicyEmbed from '../src/ReturnPolicyEmbed.tsx';
export default ReturnPolicyEmbed;
